import { OverflowMenu } from 'src/shared/design-system/OverflowMenu';
import { Clickable } from 'src/shared/design-system/Utilities';
import styled from 'styled-components';
import { Colors, Font, Spacing } from 'web-common/src/shared/styles';

export const Link = styled(Clickable).attrs(() => ({
  styleAsLink: true,
}))`
  color: ${Colors.GRAY_DARK_10};
  font-weight: 300;
  padding: 0;
  ${Font.bySize(Font.Size.S)}
`;

export const MenuLink = styled(Clickable).attrs(() => ({
  styleAsLink: true,
}))`
  color: ${Colors.AQUA};
  cursor: pointer;
  font-weight: 300;
  padding: 0;
  text-decoration: none;
  white-space: nowrap;
  ${Font.bySize(Font.Size.S)}
`;

export const NoFollowTextContainer = styled.div`
  background: ${Colors.GRAY_LITE_30};
  color: ${Colors.GRAY_DARK_10};
  display: flex;
  flex-direction: column;
  gap: ${Spacing.SINGLE};
  margin: ${Spacing.HALF};
  padding: ${Spacing.SINGLE_HALF};
  font-style: italic;
  ${Font.bySize(Font.Size.S)}
`;

export const Menu = styled(OverflowMenu).attrs(() => ({ isVerticalIcon: true }))`
  color: ${Colors.GRAY_DARK_10};
`;

export const FollowingCuisineContainer = styled.div`
  align-items: center;
  display: flex;
  gap: ${Spacing.HALF};
`;

export const FollowingCuisineDivider = styled.div`
  height: ${Spacing.SINGLE};
  width: 1px;
  background: ${Colors.GRAY_DARK_10};
`;
